// @ts-expect-error Shared breakpoint config is a root-level JS module.
import tailwindScreens from "../../tailwind.screens.js";

type TailwindScreen = string | { min?: string; max?: string; raw?: string };

const parseBreakpoint = (value: string | undefined, fallback: number) => {
  if (!value) {
    return fallback;
  }

  const matched = value.match(/(\d+(?:\.\d+)?)px/);

  if (!matched) {
    return fallback;
  }

  return Number(matched[1]);
};

export const getTailwindScreenMinWidth = (
  name: string,
  fallback: number,
): number => {
  const screen = (tailwindScreens as Record<string, TailwindScreen | undefined>)[
    name
  ];

  if (typeof screen === "string") {
    return parseBreakpoint(screen, fallback);
  }

  if (screen && typeof screen === "object") {
    return parseBreakpoint(screen.min, fallback);
  }

  return fallback;
};

export const TAILWIND_SM_BREAKPOINT = getTailwindScreenMinWidth("sm", 640);
export const TAILWIND_MD_BREAKPOINT = getTailwindScreenMinWidth("md", 768);
